import React from "react";
import { Logo } from "../components/Logo";

const Section = ({ title, children }) => (
  <div className="mt-8">
    <h2 className="font-serif text-xl sm:text-2xl text-gold leading-snug">{title}</h2>
    <div className="mt-3 text-gray-300 text-sm sm:text-[15px] leading-relaxed space-y-3">
      {children}
    </div>
  </div>
);

export default function Privacy() {
  return (
    <div className="min-h-screen bg-black text-white flex flex-col items-center px-4 py-10 sm:py-14">
      <div className="w-full max-w-2xl flex-1 flex flex-col">
        <a
          href="/"
          className="self-start mb-8 inline-flex items-center gap-2 text-xs sm:text-sm font-bold tracking-[0.15em] uppercase text-white/60 hover:text-gold transition-colors duration-300"
        >
          &larr; Torna al test
        </a>

        <Logo className="h-20 sm:h-24 mb-8" />

        <div className="relative gold-frame bg-[#0A0A0A] border border-white/10 px-6 sm:px-10 py-10 sm:py-12">
          <p className="text-[11px] font-bold tracking-[0.25em] text-gold uppercase">CC Elevate</p>
          <h1 className="mt-4 font-serif text-3xl sm:text-4xl text-white leading-tight">
            Informativa sulla Privacy
          </h1>
          <p className="mt-3 text-white/40 text-xs tracking-wide">Ultimo aggiornamento: agosto 2026</p>

          <Section title="1. Titolare del trattamento">
            <p>
              Il Titolare del trattamento &egrave; <strong>CC Elevate Sagl</strong>, Piazza Cioccaro 4,
              6900 Lugano (Svizzera), n. registro d&rsquo;impresa CHE-138.758.005. Email di contatto per
              la privacy: <a href="mailto:admin@cc-elevate.com" className="text-gold underline underline-offset-2 hover:text-gold-hover">admin@cc-elevate.com</a>.
            </p>
          </Section>

          <Section title="2. Dati raccolti">
            <p>
              Attraverso questo strumento raccogliamo i dati che ci fornisci volontariamente compilando il
              form, ossia: nome, cognome, indirizzo email, eventuale numero di telefono e le risposte fornite
              al questionario di autovalutazione. Raccogliamo inoltre dati tecnici minimi necessari al
              funzionamento del servizio (es. log di sistema del provider di hosting).
            </p>
          </Section>

          <Section title="3. Finalit&agrave; e base giuridica">
            <p>
              Trattiamo i tuoi dati per: (a) generare e inviarti il profilo/risultato personalizzato del
              test; (b) previo tuo consenso separato e facoltativo, inviarti la newsletter e comunicazioni
              informative o promozionali di CC Elevate.
            </p>
            <p>
              La base giuridica &egrave; il tuo <strong>consenso esplicito</strong>, prestato spuntando le
              apposite caselle nel form (art. 6.1.a GDPR; art. 6 nLPD). Ogni consenso &egrave; revocabile in
              qualsiasi momento scrivendo all&rsquo;indirizzo di contatto indicato al punto 1, senza
              pregiudicare la liceit&agrave; del trattamento effettuato prima della revoca.
            </p>
          </Section>

          <Section title="4. Destinatari e responsabili esterni">
            <p>
              Per erogare il servizio ci avvaliamo di fornitori che agiscono come responsabili del
              trattamento: <strong>Resend</strong> (invio email), <strong>MongoDB Atlas</strong>
              {" "}(archiviazione dei dati), <strong>Render</strong> e <strong>Netlify</strong> (hosting
              dell&rsquo;applicazione). Non vendiamo n&eacute; cediamo i tuoi dati a terzi per finalit&agrave;
              di marketing di terzi.
            </p>
          </Section>

          <Section title="5. Trasferimenti internazionali">
            <p>
              Alcuni fornitori possono trattare i dati al di fuori della Svizzera e dell&rsquo;UE (es. Stati
              Uniti). Tali trasferimenti avvengono in presenza di garanzie adeguate (clausole contrattuali
              standard e/o meccanismi di adeguatezza riconosciuti).
            </p>
          </Section>

          <Section title="6. Conservazione">
            <p>
              Conserviamo i dati per il tempo necessario alle finalit&agrave; indicate e comunque non oltre
              24 mesi dall&rsquo;ultimo contatto utile, salvo revoca anticipata del consenso o richiesta di
              cancellazione.
            </p>
          </Section>

          <Section title="7. Diritti dell&rsquo;interessato">
            <p>
              Hai diritto di accesso, rettifica, cancellazione, limitazione, portabilit&agrave; e
              opposizione. Per esercitarli scrivi a{" "}
              <a href="mailto:admin@cc-elevate.com" className="text-gold underline underline-offset-2 hover:text-gold-hover">admin@cc-elevate.com</a>.
            </p>
            <p>
              Puoi inoltre proporre reclamo all&rsquo;autorit&agrave; competente: in Svizzera, l&rsquo;Incaricato
              federale della protezione dei dati e della trasparenza (IFPDT); nell&rsquo;UE, l&rsquo;autorit&agrave;
              di controllo del tuo Stato di residenza (in Italia, il Garante per la protezione dei dati
              personali).
            </p>
          </Section>

          <Section title="8. Consenso">
            <p>
              Spuntando la casella di accettazione nel form dichiari di aver letto la presente informativa e
              acconsenti al trattamento dei tuoi dati per le finalit&agrave; indicate. Il consenso alla
              newsletter &egrave; separato e facoltativo.
            </p>
          </Section>

          <p className="mt-12 text-center text-[10px] tracking-[0.25em] text-white/30 uppercase">
            CC-ELEVATE.COM &nbsp;&middot;&nbsp; &copy; 2026 CC Elevate
          </p>
        </div>
      </div>
    </div>
  );
}
